import { startCacheWorker } from '@betterment/js-runtime';
import { accordions, dropdowns, faqs } from '@betterment/style-closet-legacy';
import Rails from '@rails/ujs';
import jQuery from 'jquery';

import { startStimulusApplication } from '../../index';

import '../vendor/jSignature';
import '../vendor/jQuerySpinnerPlugin';
import '../vendor/webshim.range-input';
import '../vendor/modernizr';
import '../vendor/d3';
import '../scripts/behaviors';
import '../scripts/form_behaviors';

(window as any).$ = jQuery;
(window as any).jQuery = jQuery;

accordions();
dropdowns();
faqs();

if (!window._rails_loaded) Rails.start();

void startStimulusApplication();
startCacheWorker();

/**
 * DO NOT DELETE
 *
 * This stub objection is meant to be a shim for mobile WebViews that still relies on Turbolinks existing in the window
 *
 * This shim can only be deleted once Turbolinks is deleted from mobile:
 * https://github.com/Betterment/mobile/blob/0690dc49f86bab87e0b061e45d91b49280541e0b/app/ios/Podfile#L61
 */
// @ts-ignore read above comment
window.Turbolinks = {
  controller: {
    restorationIdentifier: '',
    adapter: null,
  },
};
